export default function validateSearchForm(data) {
    const { origin, destination, origin2, destination2, adults, children, departureDate, returnDate, tripType, cabinType } = data;

    function notEmpty(e) {
        return !empty(e);
    }

    function empty(e) {
        if (typeof e === 'undefined') {
            return true;
        } else if (typeof e === 'string') {
            e = e.trim();
        }

        switch (e) {
            case '':
            case 0:
            case '0':
            case null:
            case false:
                return true;
            default:
                return false;
        }
    }

    function invalidOpenJaw() {
        return tripType === 'openjaw' && (empty(origin2) || empty(destination2));
    }

    function invalidReturnDate() {
        return tripType !== 'oneway' && empty(returnDate);
    }

    return (
        notEmpty(origin) &&
        notEmpty(destination) &&
        notEmpty(adults) &&
        Array.isArray(children) &&
        notEmpty(departureDate) &&
        notEmpty(cabinType) &&
        !invalidReturnDate() &&
        !invalidOpenJaw()
    );
}
